import axios from 'axios';
import { Helpers } from '../helpers/Helpers';
import { AddEntityCustomFieldRequest } from '../models/request/bankAccountTransaction/AddEntityCustomFieldRequest';
import { GetBankAccountTransactionListPagingAndFilterRequest } from '../models/request/bankAccountTransaction/GetBankAccountTransactionListPagingAndFilterRequest';

export class BankAccountTransactionService {
    static async getBankAccountTransactionList() {
        try {
            var inputObj = {

            };

            console.log('SERVICE CALL - getBankAccountTransactionList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/BankAccountTransaction/getBankAccountTransactionList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async exportBankAccountTransactionList(inputObj: GetBankAccountTransactionListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - exportBankAccountTransactionList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/BankAccountTransaction/exportBankAccountTransactionList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getBankAccountTransactionListPagingAndFilter(inputObj: GetBankAccountTransactionListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - GetBankAccountTransactionListPagingAndFilter', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/BankAccountTransaction/GetBankAccountTransactionListPagingAndFilter', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getBankMovementPopUp(_selectedIds: string[], _entityId: string, isFirstTime: boolean) {
        try {
            var inputObj = {
                selectedIds: _selectedIds,
                entityId: _entityId,
                isFirstTime: isFirstTime
            }

            console.log('SERVICE CALL - GetBankMovementPopUp', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/BankAccountTransaction/GetBankMovementPopUp', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async addBankAccountTransaction(_bankAccountTransactionId: string | undefined, _name: string | undefined, _openingBalance: string | undefined, _currencyTypeId: string | undefined, _accountingCode: string | undefined, _openingBalanceDate: string | undefined, _isCustomActive: number) {
        try {

            var inputObj = {
                bankAccountTransactionId: _bankAccountTransactionId,
                name: _name,
                openingBalance: _openingBalance,
                currencyTypeId: _currencyTypeId,
                accountingCode: _accountingCode,
                openingBalanceDate: _openingBalanceDate,
                isCustomActive: _isCustomActive,
            }

            console.log('SERVICE CALL - AddBankAccountTransaction', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/BankAccountTransaction/AddBankAccountTransaction', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async addEntityCustomField(inputObj: AddEntityCustomFieldRequest) {
        try {
            console.log('SERVICE CALL - AddEntityCustomField', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/BankAccountTransaction/AddEntityCustomField', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async deleteBankAccountTransaction(_ids: string[]) {
        try {
            var inputObj = {
                ids: _ids
            };

            console.log('SERVICE CALL - deleteBankAccountTransaction', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/BankAccountTransaction/deleteBankAccountTransaction', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getBankAccountTransactionById(_id: string) {
        try {
            var inputObj = {
                id: _id
            };

            console.log('SERVICE CALL - getBankAccountTransactionById', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/BankAccountTransaction/getBankAccountTransactionById', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }
}